package br.com.texeratx.boardgametimeapp.data.model.player

import kotlinx.serialization.Serializable

@Serializable
data class PlayerNameDTO(
    val id: Long,
    val name: String
)
